module.exports = __webpack_public_path__ + "static/media/webm.bd8471f1.svg";